module.exports = __webpack_public_path__ + "static/media/banner@768.18981d7f.png";